import {useMemo, useState} from 'react';
import {useWindowSize} from '@react-hook/window-size';
import Modal from '../Modal';
import styles from './index.module.css';
import {
  LogoutIconSvg,
} from 'components/SvgIcon';
import {NavLink} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from 'state';
import {useTranslation} from 'react-i18next';
import OverviewIcon from 'components/SvgIcon/overviewIcon';
import CustomersIcon from 'components/SvgIcon/CustomersIcon';
import SvgDarkIcon from 'components/SvgIcon/LogoDark';

export const getNavbarItems = (isHotel: boolean) => [
  {
    to: '/overview',
    title: 'common.overview',
    iconSmall: <OverviewIcon size={23} fill="black" />,
    icon: <OverviewIcon fill="black" />,
    disabled: false,
  },
  {
    to: '/customers',
    title: 'common.customers',
    iconSmall: <CustomersIcon fill="black" size={23} />,
    icon: <CustomersIcon fill="#fff" />,
    disabled: false,
  },
];

interface Props {
  requestLogout: () => void;
  isMobileOpen?: boolean;
  onMobileClose?: () => void;
}

const Navbar: React.FC<Props> = ({requestLogout, isMobileOpen, onMobileClose}) => {
  useWindowSize();
  const {t} = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isHotel = useSelector((state: RootState) => state.profile.isHotel);
  const navbarItems = useMemo(() => getNavbarItems(isHotel), [isHotel]);
  const isActive = (to: string) => {
    return window.location.pathname === to;
  };

  const handleNavClick = () => {
    if (onMobileClose) {
      onMobileClose();
    }
  };

  return (
    <>
      {isMobileOpen && (
        <div className={styles.mobileOverlay} onClick={onMobileClose} />
      )}
      <div className={`${styles.navBarContainer} ${isMobileOpen ? styles.mobileOpen : ''}`}>
        <button 
          className={styles.closeButton}
          onClick={onMobileClose}
          aria-label="Close menu"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div>
          <div className={styles.logo}>
            <SvgDarkIcon size={125}/>
            <div className={styles.separator} />
          </div>
          <nav className={styles.nav}>
            <ul>
              {navbarItems.map(({to, title, iconSmall, disabled}) => (
                <li
                  key={title}
                  style={{
                    backgroundColor: isActive(to) ? '#F5F5FB' : 'transparent',
                    borderRadius: '12px',
                  }}
                  onClick={handleNavClick}
                >
                  {disabled ? (
                    <NavLink
                      activeClassName={styles.active}
                      className={styles.linkDisabled}
                      to={to}
                    >
                      {iconSmall}
                      {/* {height > 620 && icon} */}
                      <span className={styles.titleNav}>
                        {t(title)}{' '}
                        <span id={styles.comingSoon}>(coming soon)</span>
                      </span>{' '}
                    </NavLink>
                  ) : (
                    <NavLink
                      activeClassName={styles.active}
                      className={styles.link}
                      to={to}
                    >
                      {iconSmall}
                      {/* {height > 620 && icon} */}
                      <span className={styles.titleNav}>{t(title)}</span>{' '}
                    </NavLink>
                  )}
                </li>
              ))}
              {/* <LanguageSwitcher /> */}
            </ul>
          </nav>
        </div>
        <div
          onClick={() => {
            requestLogout();
            handleNavClick();
          }}
          className={`${styles.link} ${styles.logoutWrapper}`}
        >
          <LogoutIconSvg fill="black" size={23} />
          <span className={styles.titleNav}>{t('common.logout')}</span>{' '}
        </div>
        {showLogoutModal && (
          <Modal
            title={t('common.confirmLogout')}
            requestClose={() => setShowLogoutModal(false)}
          />
        )}
      </div>
    </>
  );
};

export default Navbar;
